import { render, staticRenderFns } from "./BillTypeDialog.vue?vue&type=template&id=1c8cc696&scoped=true&"
import script from "./BillTypeDialog.vue?vue&type=script&lang=js&"
export * from "./BillTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./BillTypeDialog.vue?vue&type=style&index=0&id=1c8cc696&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cc696",
  null
  
)

export default component.exports